import { useAuth0 } from "@auth0/auth0-react";
import { useMsal } from "@azure/msal-react";
import {
  faFloppyDisk,
  faFolderOpen,
} from "@fortawesome/free-regular-svg-icons";
import {
  faArrowsRotate,
  faHome,
  faSignOut,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmationModal from "Components/Atoms/ConfirmationModal";
import { CLEAR_ANSWERS_CONFIRMATION_TEXT } from "Constants/texts";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { emptyModule, removeTerm } from "feature/app/actions";
import { motion } from "framer-motion";
import useConfirmation from "hooks/useConfirmation";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { selectUserId, setMenuShowing } from "../../Redux/UserSlice";
import {
  selectIsAuth0AuthenticationUsed,
  selectIsMSAuthenticationUsed,
  selectIsNobocapAuthenticationUsed,
  selectModule,
  selectModuleState,
  selectSavingProgress,
  selectToBePrinted,
  setAuthType,
  setReset,
  setSavingProgress,
  setUserProgress,
} from "../../Redux/appSlice";
import AlternativeButton from "../Atoms/AlternativeButton";
import Button from "../Atoms/Button";
import ExitButton from "../Atoms/ExitButton";
import MenuItem from "../Atoms/MenuItem";
import Progress from "./Progess";

/*
  @function Menu
  render a menu page that shows menu voices
  @params children {React.Node} - content to fill the page
  @returns {React.Node} 
*/
export default function HoverPage() {
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const dispatch = useAppDispatch();
  const userId = useAppSelector(selectUserId);
  const savingProgress = useAppSelector(selectSavingProgress);
  const isMsAuthenticationUsed = useAppSelector(selectIsMSAuthenticationUsed);
  const isAuth0AuthenticationUsed = useAppSelector(
    selectIsAuth0AuthenticationUsed
  );
  const module = useAppSelector(selectModule);
  const moduleState = useAppSelector(selectModuleState);
  const { logout } = useAuth0();
  const { instance } = useMsal();
  const [mouseOver, setMouseOver] = useState(false);
  const [progressShow, setProgressShow] = useState(false);
  const [progressSave, setProgressSave] = useState(false);
  const [progressName, setProgressName] = useState("");
  const toBePrinted = useAppSelector(selectToBePrinted);
  const isNobocapAuthenticationUsed =  useAppSelector(selectIsNobocapAuthenticationUsed)
  const navigate = useNavigate();
  const [
    isConfirmNavigationToHome,
    confirmNavigateHome,
    onConfirmNavigateToHome,
    onCancelNavigateToHome,
  ] = useConfirmation({
    onConfirm: () => {
      dispatch(setMenuShowing());
      navigate("/");
    },
  });

  useEffect(() => {
    if (savingProgress === "saved") {
      setProgressSave(false);
      dispatch(setSavingProgress());
    }
  }, [savingProgress]);

  useEffect(() => {
    function handleResize() {
      setScreenSize(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="absolute z-50  h-full w-full bg-black/50"
      onClick={() => (!mouseOver ? dispatch(setMenuShowing()) : null)}
    >
      <ConfirmationModal
        isOpen={isConfirmNavigationToHome}
        content={CLEAR_ANSWERS_CONFIRMATION_TEXT}
        onContinue={onConfirmNavigateToHome}
        onCancel={onCancelNavigateToHome}
      />
      <motion.div
        className={"mt-22 absolute z-50 h-full w-96 border-l-2 bg-white"}
        initial={{ x: "100vw" }}
        animate={{ x: `${screenSize - 384}px` }}
        transition={{ type: "spring", damping: 30 }}
        onMouseEnter={() => setMouseOver(true)}
        onMouseLeave={() => setMouseOver(false)}
      >
        <div className="absolute left-2 top-2 ">
          <ExitButton onClick={() => dispatch(setMenuShowing())} />
        </div>
        <div className="mt-4 p-9">
          <MenuItem
            label="CHOOSE SERVICE MODULE"
            icon={
              <div className="h-6 w-8">
                <FontAwesomeIcon icon={faHome} />
              </div>
            }
            onClick={confirmNavigateHome}
          />
          <MenuItem
            label="LOGOUT"
            icon={
              <div className="h-6 w-8">
                <FontAwesomeIcon icon={faSignOut} />
              </div>
            }
            onClick={() => {
              window.localStorage.setItem("clientId", "");
              window.localStorage.setItem("tenantId", "");
              window.localStorage.removeItem("oid");
              window.localStorage.setItem("token", "");
              window.userToken = undefined;
              localStorage.setItem("portal", "");
              dispatch(setAuthType(""));
              isAuth0AuthenticationUsed &&
                logout({ returnTo: "https://www.leanentries.com" });
              if (isMsAuthenticationUsed) {
                const logoutRequest = {
                  mainWindowRedirectUri: "https://www.leanentries.com",
                  postLogoutRedirectUri: "https://www.leanentries.com",
                };
                instance.logoutPopup(logoutRequest);
              }
              if( isNobocapAuthenticationUsed) {
                window.location.href = "https://portal.nobocap.eu/login";
              }
            }}
          />
          {window.location.pathname.match("^/organization/.*/module/.*") && (
            <MenuItem
              label="CLEAR ALL ANSWERS"
              icon={
                <div className="h-6 w-8">
                  <FontAwesomeIcon icon={faArrowsRotate} />
                </div>
              }
              onClick={() => {
                dispatch(
                  setReset(() => {
                    dispatch(setMenuShowing());
                    dispatch(emptyModule());
                    dispatch(removeTerm("all"));
                    window.location.reload();
                  })
                );
              }}
            />
          )}
          {window.location.pathname.match("^/organization/.*/module/.*") && (
            <MenuItem
              label="SAVE"
              icon={
                <div className="h-6 w-8">
                  <FontAwesomeIcon icon={faFloppyDisk} />
                </div>
              }
              onClick={() => setProgressSave(!progressSave)}
            />
          )}
          {window.location.pathname.match(
            "^/producer/organization/.*/module/.*"
          ) && (
            <Link
              to={
                window.location.pathname
                  .replace("/links", "")
                  .replace("/references", "") + "/terms"
              }
              onClick={() => dispatch(setMenuShowing())}
            >
              <MenuItem
                label="TERMS"
                icon={
                  <div className="h-6 w-8">
                    <FontAwesomeIcon icon={faHome} />
                  </div>
                }
              />
            </Link>
          )}
          {window.location.pathname.match(
            "^/producer/organization/.*/module/.*"
          ) && (
            <Link
              to={
                window.location.pathname
                  .replace("/terms", "")
                  .replace("/references", "") + "/links"
              }
              onClick={() => dispatch(setMenuShowing())}
            >
              <MenuItem
                label="LINKS"
                icon={
                  <div className="h-6 w-8">
                    <FontAwesomeIcon icon={faHome} />
                  </div>
                }
              />
            </Link>
          )}
          {window.location.pathname.match(
            "^/producer/organization/.*/module/.*"
          ) && (
            <Link
              to={
                window.location.pathname
                  .replace("/links", "")
                  .replace("/terms", "") + "/references"
              }
              onClick={() => dispatch(setMenuShowing())}
            >
              <MenuItem
                label="REFERENCES"
                icon={
                  <div className="h-6 w-8">
                    <FontAwesomeIcon icon={faHome} />
                  </div>
                }
              />
            </Link>
          )}
          {window.location.pathname.match(
            "^/producer/organization/.*/module/.*"
          ) && (
            <Link
              to={window.location.pathname
                .replace("/links", "")
                .replace("/terms", "")
                .replace("/references", "")}
              onClick={() => dispatch(setMenuShowing())}
            >
              <MenuItem
                label="BACK TO MODULE PRODUCER"
                icon={
                  <div className="h-6 w-8">
                    <FontAwesomeIcon icon={faHome} />
                  </div>
                }
              />
            </Link>
          )}
          {progressSave && (
            <div className="flex flex-col justify-center gap-2">
              <input
                type="text"
                className="mx-12 mb-2 border-2"
                value={progressName}
                onChange={(e) => setProgressName(e.target.value)}
              />
              <div className="flex flex-row gap-2">
                <Button
                  label="SAVE"
                  onClick={() => {
                    if (module?.module_id && userId && moduleState) {
                      dispatch(
                        setUserProgress({
                          moduleId: module?.module_id,
                          userId: userId,
                          name: progressName,
                          data: moduleState.initialization,
                          toBePrinted,
                        })
                      );
                    }
                  }}
                />
                <AlternativeButton
                  label="CANCEL"
                  onClick={() => setProgressSave(!progressSave)}
                />
              </div>
            </div>
          )}
          {window.location.pathname.match("^/organization/.*/module/.*") && (
            <MenuItem
              label="OPEN PROGRESS"
              icon={
                <div className="h-6 w-8">
                  <FontAwesomeIcon icon={faFolderOpen} />
                </div>
              }
              onClick={() => setProgressShow(!progressShow)}
            />
          )}
          {progressShow && <Progress />}
        </div>
      </motion.div>
    </div>
  );
}
